import { defineStore } from "pinia"

export const useTicketListConfigStore = defineStore("ticketListConfig", {
    state: () => {
        return {
            ticketListConfig: []
        }
    },

    getters: {},

    actions: {},

    persist: {
        storage: localStorage
    }
})